module.exports = __webpack_public_path__ + "img/DailyBonus_2208x1242_3.cbf1110c.png";